


const paths = {
  'user_facebook_omniauth_authorize_path': '/auth/facebook', 'user_google_oauth2_omniauth_authorize_path': '/auth/google_oauth2', 'user_vkontakte_omniauth_authorize_path': '/auth/vkontakte', 'user_yandex_omniauth_authorize_path': '/auth/yandex'
};

export default paths;